import type {
  GetProfileInfoResponse,
  ReferralLink,
  ReflinkResponse,
  SetBalanceAlertResponse,
} from '@/api';
import { ProfileData, BalanceAlertData } from '../models';

const getProfileInfo = (response: GetProfileInfoResponse): ProfileData => {
  const { data } = response;
  return data;
};

const getBalanceAlert = (
  response: SetBalanceAlertResponse,
): BalanceAlertData => {
  const { data } = response;
  return data;
};

const getReflinksData = (response: ReflinkResponse): ReferralLink[] => {
  const { data } = response;
  return data;
};

export { getProfileInfo, getBalanceAlert, getReflinksData };
